import "./RestaurantPage.css";
import plusIcon from "../../icons/plusIcon.svg";
import ProductsComponent from "../../components/productsComponent/products";
import { useEffect, useState } from "react";
import CreateProductComponent from "../../components/createProductComponent/createProductComponent";
import { useShowBoxContext } from "../../context/boxRestaurantContext";
import DealEditComponent from "../../components/dealDetailComponent/dealEdit";
import { SettingOutlined } from "@ant-design/icons";
import ProductEditComponent from "../../components/productDetailsEditComponent/productDetailsEditComponent";
import CardLoading from "../../components/cardAntLoading/cardAntLoading";
import secureLocalStorage from "react-secure-storage";
import ActiveAndDeactiveProductsModal from "../../components/activeAndDeactiveProductsModal/activeAndDeactiveProductsModal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { restaurantsAll } from "../../services/restaurants";
import {
  updateOrderInProducts,
  listProductCategories,
  listRestaurantShowcases,
  getProductCompleteInfo,
  listProductRestaurant,
  create_restaurant_showcase,
} from "../../services/products";
import { getDealById } from "../../services/deal";
import { updateDealStatus } from "../../services/deal";
import { update_restaurant_showcase } from "../../services/products";
import { Button, Form, InputNumber, Modal, notification, Select } from "antd";
export default function RestaurantPage() {
  const [productSelected, setProductSelected] = useState({});
  const [productShowCaseId, setProductShowCaseId] = useState("");
  const [dealSelect, setDealSelect] = useState({});
  const [itemsSelected, setItemsSelected] = useState("");
  const [modalSettings, setModalSettings] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [needReload, setNeedReload] = useState(false);
  const [listToUpdate, setListToUpdate] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [editedOrder, setEditedOrder] = useState(false);
  const { isBoxVisible, showCreateProductBox, isEdit, showEditProduct } =
    useShowBoxContext();
  const [form] = Form.useForm();
  const [categoriesLoaded, setCategoriesLoaded] = useState(true);
  const [filtredItems, setFiltredItems] = useState([]);
  const [productsShowcase, setProductsShowcase] = useState([]);
  const [productsDeals, setProductsDeals] = useState([]);
  const [isEditDeal, setIsEditDeal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLinkProductModalOpen, setIsLinkProductModalOpen] = useState(false);
  const [linkProductForm] = Form.useForm();
  const [regularProducts, setRegularProducts] = useState([]);
  const [restaurantsList, setRestaurantsList] = useState([]);
  const [itensEditStatus, setItensEditStatus] = useState([]);
  var restaurantId = secureLocalStorage.getItem("restaurant");
  async function loadProductsAndCategories() {
    if (!restaurantId) {
      console.error("ID do restaurante não encontrado.");
      return;
    }

    try {
      const categoriesData = await listProductCategories({
        limit: 100,
        offset: 0,
      });
      if (!categoriesData || !Array.isArray(categoriesData.items)) {
        console.error("Dados de categorias inválidos ou não carregados");
        return;
      }
      const showcasesData = await listRestaurantShowcases({
        restaurantId,
        limit: 100,
        offset: 0,
      });

      const showcases = showcasesData.showcases;
      const deals = showcasesData.deals;
      setProductsShowcase(showcases);
      setProductsDeals(deals);
      setFiltredItems([...deals, ...showcases]);
      setCategoriesLoaded(false);
    } catch (err) {
      console.error("Erro ao carregar categorias e produtos:", err);
    }
  }

  useEffect(() => {
    loadProductsAndCategories();
  }, [restaurantId]);

  const handleOkProduct = () => {
    showCreateProductBox();
  };

  const handleCancelProduct = () => {
    showCreateProductBox();
  };

  const handleOkEdit = () => {
    showEditProduct();
  };

  const handleCancelEdit = () => {
    form.resetFields();
    showEditProduct();
  };

  useEffect(() => {
    if (isLinkProductModalOpen) {
      loadRegularProducts();
      loadRestaurants();
    }
  }, [isLinkProductModalOpen]);

  const loadRegularProducts = async () => {
    try {
      const responseRegular = await listProductRestaurant({
        limit: 1000,
        offset: 0,
        type: "regular",
      });
      const responseCombo = await listProductRestaurant({
        limit: 1000,
        offset: 0,
        type: "combo",
      });

      setRegularProducts([...responseRegular.items, ...responseCombo.items]);
    } catch (error) {
      console.error("Erro ao carregar produtos:", error);
    }
  };

  const loadRestaurants = async () => {
    try {
      const response = await restaurantsAll(1000, 0);
      setRestaurantsList(response.items || []);
    } catch (error) {
      console.error("Erro ao carregar restaurantes:", error);
    }
  };

  const handleLinkProduct = async (values) => {
    const user = secureLocalStorage.getItem("user_id");
    try {
      const currentTime = new Date();
      const hours = String(currentTime.getHours()).padStart(2, "0");
      const minutes = String(currentTime.getMinutes()).padStart(2, "0");
      const seconds = String(currentTime.getSeconds()).padStart(2, "0");
      const timeString = `${hours}:${minutes}:${seconds}`;

      const selectedProduct = regularProducts.find(
        (product) => product.id === values.restaurant_product_id
      );

      if (!selectedProduct) {
        notification.error({
          message: "Erro",
          description: "Produto selecionado não encontrado.",
        });
        return;
      }
      const categoryId = selectedProduct.category;

      const showcaseData = {
        restaurant_id: values.restaurant_id,
        restaurant_product_category_id: categoryId,
        restaurant_product_id: values.restaurant_product_id,
        status: "active",
        sequence: 1,
        price: values.price,
        weekday: [1, 2, 3, 4, 5, 6, 7],
        start: timeString,
        end: timeString,
        created_by: user,
      };

      await create_restaurant_showcase({ showcase: showcaseData });

      notification.success({
        message: "Produto vinculado com sucesso",
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      setIsLinkProductModalOpen(false);
      linkProductForm.resetFields();
    } catch (error) {
      console.error("Erro ao vincular produto:", error);
      notification.error({
        message: "Erro ao vincular produto",
        description: error.response?.data?.message || "Erro inesperado",
      });
    }
  };

  const callBackClickEditProduct = async (product) => {
    try {
      console.log("productFilter", product);

      const typeProduct = product.product_id ? "product" : "deal";
      const productId = product.product_id ? product.product_id : product.id;
      console.log("productFilter typeProduct", typeProduct);
      console.log("productFilter productId", productId);
      let productData = {};
      if (typeProduct === "product") {
        productData = await getProductCompleteInfo({ productId, restaurantId });
        setProductSelected(productData);
        setProductShowCaseId(product.id);
        showEditProduct();
      } else {
        productData = await getDealById({ dealId: productId });
        setDealSelect(productData);
        setIsEditDeal(true);
        console.log("productFilter productData", productData);
      }
    } catch (error) {
      console.error("Erro ao carregar os detalhes do produto:", error);
    }
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  
  const onDragEnd = (result) => {
    if (!result.destination) return;
  
    const newItems = reorder(
      productsShowcase,
      result.source.index,
      result.destination.index
    );
    console.log("newItems", newItems);
    setProductsShowcase(newItems);
    setEditedOrder(true);
  };
  function saveOrder() {
    setCategoriesLoaded(true);
    const orderCategories = productsShowcase.map((item, index) => ({
      group_name: item.group_name,
      group_index: index + 1,
    }));
    console.log("orderCategories", orderCategories);
    updateOrderInProducts({
      restaurantId: restaurantId,
      order_products: orderCategories,
    }).then(() => {
      setCategoriesLoaded(false);
      setEditedOrder(false);
      setTimeout(() => {
        window.location.reload();
      });
    });
  }
  const handleSaveUpdates = async () => {
    const isDeal = itensEditStatus.some(
      (item) => item && item.deal_compositions
    );
    setLoadingButton(true);
    if (isDeal) {
      try {
        const promises = listToUpdate.map((item) =>
          updateDealStatus({
            dealId: item.id,
            status: item.is_enabled ? "active" : "inactive",
          })
        );
        await Promise.all(promises);
  
        setLoadingButton(false);
        notification.success({
          message: "Sucesso",
          description: "Produtos atualizados com sucesso.",
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        setLoadingButton(false);
        notification.error({
          message: "Erro",
          description: "Não foi possível atualizar o status dos produtos.",
        });
      }
  
      return;
    }

    try {
      const promises = listToUpdate.map((productToUpdate) =>
        update_restaurant_showcase({
          showcaseId: productToUpdate.id,
          requestBody: {
            status: productToUpdate.is_enabled ? "active" : "inactive",
          },
        })
      );
      await Promise.all(promises);
  
      setLoadingButton(false);
      notification.success({
        message: "Sucesso",
        description: "Produtos atualizados com sucesso.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      setLoadingButton(false);
      notification.error({
        message: "Erro",
        description: "Não foi possível salvar as alterações.",
      });
    }
  };
  

  return (
    <>
      <div className="body_main">
        <div className="products_container">
          <div className="products_navbar">
            <h3 className="products_navbar_item">Produtos</h3>

            <div className="products_navbar_item">
              <div>
                <button onClick={() => showCreateProductBox()}>
                  <img src={plusIcon} alt="plusIcon" />
                  <span>Adicionar Produto</span>
                </button>
                <br />
                <button onClick={() => setIsLinkProductModalOpen(true)}>
                  <img src={plusIcon} alt="plusIcon" />
                  <span>Vincular Produto</span>
                </button>

              </div>
              <Modal
                title="Vincular Produto"
                visible={isLinkProductModalOpen}
                onCancel={() => setIsLinkProductModalOpen(false)}
                footer={null}
              >
                <Form
                  form={linkProductForm}
                  onFinish={handleLinkProduct}
                  layout="vertical"
                >
                  <Form.Item
                    label="Restaurante"
                    name="restaurant_id"
                    rules={[
                      { required: true, message: "Selecione um restaurante" },
                    ]}
                  >
                    <Select placeholder="Selecione um restaurante">
                      {restaurantsList.map((restaurant) => (
                        <Select.Option
                          key={restaurant.id}
                          value={restaurant.id}
                        >
                          {restaurant.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Produto"
                    name="restaurant_product_id"
                    rules={[
                      { required: true, message: "Selecione um produto" },
                    ]}
                  >
                    <Select placeholder="Selecione um produto">
                      {regularProducts.map((product) => (
                        <Select.Option key={product.id} value={product.id}>
                          {product.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Preço"
                    name="price"
                    rules={[{ required: true, message: "Insira o preço" }]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      min={0}
                      step="0.01"
                      formatter={(value) => `R$ ${value}`}
                      parser={(value) => value.replace("R$ ", "")}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Vincular
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
              <div
                onClick={() => setItemsSelected(null)}
                className={
                  !itemsSelected
                    ? `category_item_all ative`
                    : `category_item_all`
                }
              >
                PROMOÇÕES
              </div>

              {productsDeals.map((item, index) => (
                <div
                  style={{
                    userSelect: "none",
                    padding: 6,
                    margin: `0 0 8px 0`,
                    background: "#FFF",
                    color: "#6a2a40",
                  }}
                >
                  <div
                    onClick={() => {
                      setItemsSelected(item.name);
                      setFiltredItems([item]);
                    }}
                    className={
                      itemsSelected === item.name
                        ? `category_item ative`
                        : `category_item`
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ flex: 1 }}>{item.name}</p>
                      <SettingOutlined
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          setItensEditStatus([item]);
                          setModalSettings(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}

              <div
                onClick={() => setItemsSelected(null)}
                className={
                  !itemsSelected
                    ? `category_item_all ative`
                    : `category_item_all`
                }
              >
                TODOS
              </div>
              {editedOrder && (
                <button
                  onClick={() => saveOrder()}
                  style={{ marginTop: 10, marginBottom: 10 }}
                  className="button_update_order"
                >
                  <span>Salvar alterações de ordem</span>
                </button>
              )}
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{
                        background: snapshot.isDraggingOver
                          ? "lightblue"
                          : "lightgrey",
                        padding: 8,
                      }}
                    >
                      {productsShowcase.map((item, index) => (
                        <Draggable
                          key={item.group_name}
                          draggableId={`${item.group_name}`}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                userSelect: "none",
                                padding: 6,
                                margin: `0 0 8px 0`,
                                background: "#FFF",
                                color: "#6a2a40",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div
                                onClick={() => {
                                  console.log("itemsToFilter", item);
                                  setItemsSelected(item.group_name);
                                  setFiltredItems([item]);
                                }}
                                className={
                                  itemsSelected === item.group_name
                                    ? `category_item ative`
                                    : `category_item`
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <p style={{ flex: 1 }}>{item.group_name}</p>
                                  <SettingOutlined
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                      setItensEditStatus(item.items);
                                      setModalSettings(true);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>

          <div className="products_category_container">
            {!categoriesLoaded ? (
              <>
                {filtredItems.map((item, index) => {
                  return (
                    <div key={item.id} className="products_category_box">
                      <div className="products_category_text">
                        {item.group_name ? item.group_name : item.name}
                      </div>
                      <ProductsComponent
                        callBackClickEditProduct={callBackClickEditProduct}
                        products={item.items ? item.items : [item]}
                        updateProducts={() => loadProductsAndCategories()}
                      />
                    </div>
                  );
                })}
              </>
            ) : (
              <CardLoading />
            )}
          </div>
        </div>
        <Modal
          width={"50%"}
          style={{ top: 10 }}
          open={isBoxVisible}
          onCancel={handleCancelProduct}
          onOk={handleOkProduct}
          okButtonProps={{ disabled: true, hidden: true }}
          cancelButtonProps={{ disabled: true, hidden: true }}
        >
          <CreateProductComponent
            productsParams={allProducts}
            restaurantId={localStorage.getItem("restaurant")}
          />
        </Modal>
        <Modal
          width={"50%"}
          style={{ top: 10 }}
          open={isEdit}
          onCancel={handleCancelEdit}
          onOk={handleOkEdit}
          okButtonProps={{ disabled: true, hidden: true }}
          cancelButtonProps={{ hidden: true }}
        >
          {isEdit && (
            <ProductEditComponent
              isOpen={isEdit}
              productSelect={productSelected}
              productShowCaseId={productShowCaseId}
            />
          )}
        </Modal>
        <Modal
          width={"50%"}
          style={{ top: 10 }}
          open={isEditDeal}
          onCancel={() => setIsEditDeal(false)}
          onOk={() => setIsEditDeal(false)}
          okButtonProps={{ disabled: true, hidden: true }}
          cancelButtonProps={{ hidden: true }}
        >
          {isEditDeal && <DealEditComponent productSelect={dealSelect} />}
        </Modal>
        <Modal
          width={"50%"}
          style={{ top: 10 }}
          open={modalSettings}
          onCancel={() => {
            if (needReload) window.location.reload();
            else setModalSettings(false);
          }}
          onOk={handleOkEdit}
          okButtonProps={{ disabled: true, hidden: true }}
          cancelButtonProps={{ hidden: true }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "98%",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h5>Categoria: {itemsSelected || "Categoria Selecionada"}</h5>
            <h6>Aqui você pode ativar/desativar os produtos dessa categoria</h6>
            <ActiveAndDeactiveProductsModal
              products={itensEditStatus}
              setNeedReload={setNeedReload}
              setListToUpdate={setListToUpdate}
              listToUpdate={listToUpdate}
            />
            <Button
              disabled={listToUpdate.length === 0}
              loading={loadingButton}
              onClick={handleSaveUpdates}
            >
              Salvar
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
}
